import { Sort } from "../../constants"

export const defaultPage = 1
export const defaultRowsPerPageOptions = [20, 50, 100]
export const [defaultPerPage] = defaultRowsPerPageOptions
export const directionList = [null, Sort.DESK, Sort.ASC]
